import { render, staticRenderFns } from "./FaceAccreditationDetail.vue?vue&type=template&id=393b7ad0&"
import script from "./FaceAccreditationDetail.ts?vue&type=script&lang=ts&"
export * from "./FaceAccreditationDetail.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports